"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggleProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var context_1 = require("./context");
function FeatureToggleProvider(_a) {
    var children = _a.children, isFeatureEnabled = _a.isFeatureEnabled;
    var _b = react_1.default.useState({}), features = _b[0], setFeatures = _b[1];
    var registerFeature = react_1.default.useCallback(function (name, displayName) {
        setFeatures(function (features) {
            var _a, _b;
            if (features[name]) {
                if (displayName && !features[name].displayName) {
                    return __assign(__assign({}, features), (_a = {}, _a[name] = __assign(__assign({}, features[name]), { displayName: displayName }), _a));
                }
                return features;
            }
            return __assign(__assign({}, features), (_b = {}, _b[name] = {
                name: name,
                displayName: displayName || name,
                isEnabled: isFeatureEnabled(name)
            }, _b));
        });
    }, [isFeatureEnabled]);
    var isEnabled = react_1.default.useCallback(function (name) {
        return (isFeatureEnabled(name) ||
            (features[name] && features[name].isEnabled ? true : false));
    }, [features, isFeatureEnabled]);
    var toggleFeature = react_1.default.useCallback(function (name, enable) {
        setFeatures(function (features) {
            var _a;
            return (__assign(__assign({}, features), (_a = {}, _a[name] = __assign(__assign({}, features[name]), { isEnabled: typeof enable !== "undefined" ? enable : !features[name].isEnabled }), _a)));
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(context_1.FeatureToggleContext.Provider, __assign({ value: {
            registerFeature: registerFeature,
            toggleFeature: toggleFeature,
            features: features,
            isFeatureEnabled: isEnabled
        } }, { children: children })));
}
exports.FeatureToggleProvider = FeatureToggleProvider;
